var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 8.09961L20.5 9.47461L18 11.8496V19.9996H21.5C22.3285 19.9996 23 19.3281 23 18.4996V8.09961Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.09961L3.807 8.95461L7 11.8496V19.9996H3.5C2.6715 19.9996 2 19.3281 2 18.4996V8.09961Z",
    fill: "#1E88E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5.59961L12.5 9.72461L7 5.59961L6.5 8.49961L7 11.8496L12.5 15.9746L18 11.8496L18.5 8.49961L18 5.59961Z",
    fill: "#E53935"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.149V8.1L7 11.85V5.6L5.438 4.4295C5.066 4.1505 4.614 4 4.149 4C2.962 4 2 4.962 2 6.149Z",
    fill: "#C62828"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23 6.149V8.1L18 11.85V5.6L19.562 4.4295C19.934 4.1505 20.386 4 20.851 4C22.038 4 23 4.962 23 6.149Z",
    fill: "#FBC02D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.2f872a066256b71d4a85d5b54c27dc4e.svg";
export { ForwardRef as ReactComponent };